import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Handles the #session_id=... fragment after Emergent OAuth redirect.
 *  REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */
const AuthCallback = () => {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/"); return; }
    const sid = m[1];
    // Strip fragment before navigating so a refresh doesn't retry
    window.history.replaceState({}, "", window.location.pathname);
    axios.post(`${API}/auth/session`, { session_id: sid }, { withCredentials: true })
      .then(async () => { await refresh(); nav("/"); })
      .catch(() => nav("/"));
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream">
      <p className="text-forest">Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
